import { useTranslation } from 'react-i18next'

const AdoptiveDadEnd = (props) => {
  const { t } = useTranslation()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="adoptive-dad-end-title"
      fill="none"
      {...props}
    >
      <title id="adoptive-dad-end-title">{t('antagonists:adoptiveDad:components:end')}</title>
      <path
        d="M1524.06 168.51c-4.53 1.71-29.94 3.86-33.88 14.34-3.94 10.49.88 15.6.37 24.97s5.01 16.37 5.24 22.38c.22 6 9.88 18.11 9.88 18.11l69.75-11.39s-.44-16.42-.41-24.61c.03-8.2 2.61-15.08-1.84-21.93-4.46-6.85-7.1-10.27-12.89-16.47-5.78-6.2-13.6-14.46-22.17-13.28-8.57 1.18-9.52 6.17-14.06 7.88Z"
        style={{
          fill: '#a08843',
        }}
      />
      <path
        d="M1533.08 195.59c-8.14 2.13-12.3 7.72-20.38 9.5-8.07 1.79-14.34 6.73-12.29 12.69 2.05 5.96 7.55 22.72 4.52 24.25-3.03 1.53-7.06-14.07-11.12-12.46-4.06 1.61-2.21 8.32.29 16.31 2.5 7.99 5 16.5 7.81 15.88 2.81-.62 4.88-3.38 4.88-3.38s1.7 17.34 7.68 22.78c5.98 5.44 14.9 12.81 23.21 13.82 8.32 1.01 9.88-2.5 16.15-6.12 6.17-3.57 13.17-11.72 16.01-20.42 2.16-6.61-.32-19.31 1.64-20.46 1.96-1.14 4.81 1.78 7.07-2.99 2.26-4.77 2.97-9.91 3.47-14.3s1.29-14.17-2.8-14.34c-4.08-.16-7.9 9.23-8.15 11.42-.25 2.19-2.06 4.02-3.01 1.38-.95-2.64.58-9.03-2.22-13.39-2.8-4.36-3.58-4.55-4.6-12.51-1.02-7.96-12.05-6.23-16.76-5.9-4.71.33-3.26-3.89-11.41-1.76Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1539.48 225.4-.14 3.31s8.66-3.42 14.64-1.77c5.98 1.66 8.2 1.55 8.2 1.55l.95-2.97s-6.07-4.18-12.47-4.28-11.17 4.16-11.17 4.16Zm-11.85 5.29.3-2.67s-2.23-4.82-10.56-2.95c-7.84 1.76-11.39 4.97-11.39 4.97l1.78 2.5s7.99-2.34 10.9-2.36c3.47-.02 8.97.52 8.97.52Z"
        style={{
          fill: '#a08843',
        }}
      />
      <path
        d="M1510.66 245.23s7.51 31.69 1.96 40.65c-5.55 8.95-39.91 13.08-39.91 13.08s-9.38 36.4-9.26 37.91c1.08 13.58 154.45 170.84 151.19 8.06-.03-1.54-5.65-40.19-5.65-40.19s-31.66-12.52-38.45-18.78c-6.79-6.27-1.57-24.31-1.57-29.98v-14.63l-58.31 3.88Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1532.08 268.12s.7 2.41 1.19 3.91c.5 1.49 2.05 4.04 2.05 4.04l5.12-1.61s.23-1.98.07-4.19c-.16-2.21-1.1-4.25-1.1-4.25l-7.33 2.1Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1529.62 275.43c1.01 1.68 1.29 1.52 2.75 2.95 1.45 1.43 2.7 3.37 6.77 2.63 4.07-.74 6.9-5.17 8.26-5 1.36.18 1.64-.2 1.51-1.6-.13-1.4-5.49-6.26-7.78-5.44s-2.36 2.11-2.95 2.24c-.59.13-1.23-1.27-3.64-.94-4.72.63-6.01 3.34-4.91 5.16Z"
        style={{
          fill: '#f2974a',
        }}
      />
      <path
        d="M1518.11 237.5c-1.91-.11-3.33 1.11-3.37 2.99-.03 1.88 1.15 2.71 2.86 2.92 2.02.24 3.25-.92 3.48-2.86.16-1.36-1-2.95-2.97-3.06Z"
        style={{
          fill: '#3a4b36',
        }}
      />
      <path
        style={{
          fill: '#3a4b36',
        }}
        d="m1513.52 240.51 9.07-4.09-.89-3.22-9.36 5.06 1.18 2.25zm35.25-6.64c1.89-.33 3.44.72 3.69 2.59.25 1.87-.83 2.83-2.5 3.23-1.98.47-3.33-.54-3.78-2.44-.32-1.34.65-3.04 2.6-3.38Z"
      />
      <path
        style={{
          fill: '#3a4b36',
        }}
        d="m1554.9 235.18-9.2-.83-.07-3.43 9.75 1.73-.48 2.53z"
      />
      <path
        d="M1551.19 907.65s1.14 24.51.78 37.11c-.36 12.6-1.75 31.12-1.75 31.12s7.72 4.53 8.28 8.29-.58 12.4-.58 12.4 6.05 4.81 14 4.5c7.95-.3 30.14-.94 32.21-1.43s4.38-6.04 4.38-6.04-.6-10.26-6.21-20.12c-5.61-9.86-7.11-10.64-8.17-16.48s-3.39-17.5-3.22-24.22c.16-6.72-1.44-27.01-1.44-27.01l-38.27 1.88Zm-78.43 2.42c-.39.65-.14 26.87-1.71 34.28-1.58 7.41-5.12 22.88-8.96 26.4-3.83 3.52-13.32 12.31-13.29 17.98.03 5.67-.11 17.42-.11 17.42s9.22.03 17.82.09 15.71-.24 23.55-3.08c7.84-2.85 10.62-6.53 10.62-6.53l-.18-9.44 17.23-8.91s-.57-3.54-1.63-13.99-6.71-20.29-6.43-23.45c.29-3.16 1.58-7.41 2.29-15.42s-.37-18.87-.37-18.87l-38.83 3.51Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1557.91 927.03s9.19-3.46 15.9-3.48c6.7-.02 14.01 1.64 14.01 1.64l.2 2.73s-6.46-2.07-15.28-1.09c-8.82.98-13.61 3.43-13.61 3.43l-1.21-3.23Zm-55.17 1.08s-8.1-2.35-14.02-1.97c-6.04.39-12.89 2.28-12.89 2.28l-.38 2.44s6.17-2.27 14.2-1.99c7.88.28 12.19 2.08 12.19 2.08l.89-2.85Z"
        style={{
          fill: '#99793e',
        }}
      />
      <path
        d="M1458.96 556.62s-2.85 110.86-.38 144.47c2.47 33.6 9.2 54.18 8.65 66.51-.55 12.33.81 96.27 1.52 113.36.71 17.09.07 52.96.07 52.96s12.53 5.9 25.26 3.76c12.73-2.14 23.75-6.88 23.75-6.88s4.26-13.02 2.64-26.33c-1.62-13.31 6.11-45.73 3.15-65.4-2.96-19.67.77-58.35 3.39-72.37 2.62-14.02 6.68-70.36 10.99-95.15 4.31-24.79 13.39-85.16 13.39-85.16l-5.67-37.14-86.77 7.37Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1530.87 559.79s21.2 111.22 19.53 156.2c-1.67 44.98-.48 48.88-.34 57.5.14 8.62-5.52 90.27-3.94 110.33 1.58 20.07 1.64 49.11 1.64 49.11s8.32 2.52 19.87 4.86c11.56 2.34 23.75-1.17 23.75-1.17s6.22-12.76 6.08-50.96c-.14-38.19 3.84-104.43 4.63-116.71.8-12.28-1.27-13.04 2.23-30.4s21.87-77.73 23.99-107.07-6.04-92.6-6.04-92.6l-91.41 20.92Z"
        style={{
          fill: '#0077be',
        }}
      />
      <path
        d="M1508.77 288.7s-3.44 7.03 7.59 14.63c11.04 7.6 31.39 6.56 31.39 6.56s11.96.86 19.58-10.33c5.37-7.88 3.22-13.61 3.22-13.61s14.53 5.97 30.05 12.54c15.52 6.56 37.8 8.19 39.86 16.13 2.07 7.94-23.73 72.99-20.63 94.06 3.1 21.07.69 53.88 2.07 68.73 1.38 14.85 9.15 51.66 9.15 51.66s-3.73 31.6-10.87 39.39c-13.42 14.64-66.38 21.62-111.82 18.38-36.84-2.63-49.98-24.02-49.98-24.02s-.93-9.12 0-28.56c.65-13.63-7.79-18.82 3.83-49.6 10.53-27.88 3.1-84.97-3.79-105.69-6.9-20.72-21.27-61.47-10.24-69.41 11.04-7.94 27.03-10.56 35.46-13.16 10.98-3.38 25.13-7.7 25.13-7.7Z"
        style={{
          fill: '#c3e3e8',
        }}
      />
      <path
        d="M1614.13 310.66c-19.77 13.2-6.44 68.18-.23 91.67 6.21 23.49 17.79 50.65 26.41 55.83 8.62 5.18 40.35 4.78 42.42-9.73 2.07-14.51-17.03-41.13-21.86-69.11-4.83-27.98-15.12-59.78-21.32-66.69-6.21-6.91-18.18-6.81-25.42-1.97Z"
        style={{
          fill: '#c3e3e8',
        }}
      />
      <path
        d="M1621.58 545.76s-2.88 3.09-6.4 5.27c-3.52 2.18-12.29 7.32-16.59 12.12-4.3 4.8-21.17 21.37-21.17 21.37s1.32 5.96 7.94 3.48 11.91-7.12 11.91-7.12 3.14 8.78 13.9 10.77c10.75 1.99 18.2-.83 18.2-.83s4.8-6.3 7.94-13.25c3.14-6.96 8.77-21.87 8.77-21.87l-24.48-9.94Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1466.9 301.66c-25.96-.56-39.99 26.06-49.68 50.33-8.23 20.61-21.56 35.12-31.25 53.72-9.69 18.6.52 55.22 17.18 51.11 16.66-4.11 71.78-57.51 71.78-57.51l-8.03-97.65Zm170.43 143.11s-4.85 44.36-8.49 62.29c-3.64 17.93-11.23 41.93-11.23 41.93s11.23 1.82 20.02 6.38c8.8 4.56 5.99 9.54 5.99 9.54l11.91-27.77s8.8-.61 12.14-17.01c3.34-16.41 14.87-50.44 14.87-58.03 0-7.6 2.12-17.32-4.25-24.61-6.37-7.29-39.14-9.11-40.96 7.29Z"
        style={{
          fill: '#c3e3e8',
        }}
      />
      <path
        d="M1442.3 336.85s15.86-17.49 20.17-22.92c4.3-5.44 15.9-21.86 18.44-23.85 2.54-1.99 35.63-16.82 35.63-16.82s2.69 2.04-.58 6.38-19.84 10.56-19.84 10.56 9.86-.04 11.79 1.14c1.93 1.18 2.42 6.85 1.31 8.26-1.1 1.42-1.41 2.13-1.41 2.13s2.03 1.43 1.87 5.21c-.17 3.78-2.46 3.43-2.46 3.43s4.08 3.15 1.07 6.9c-3.02 3.75-10.66 4.95-10.66 4.95s-6.23 6.5-14.91 11.25-11.11 4.55-12.21 6.94c-1.11 2.4-16.49 12.24-16.49 12.24s-11.5-15.78-11.71-15.79Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1449.99 324.08s6.06 9.04 11.75 14.21c5.69 5.17 10.51 11.61 10.51 11.61s-9.44 32.28-23.68 56.35c-14.23 24.07-45 56.93-55 50.04-10-6.9-19.83-30.44-8.25-50.44 11.58-20 25.39-44.3 39.25-55.56 13.86-11.26 25.4-26.21 25.4-26.21Z"
        style={{
          fill: '#c3e3e8',
        }}
      />
      <path
        d="M1570.82 227.65c-1.02 0-4.28.46-5.27.4-1-.06-6.28-.73-12.87.47-6.64 1.21-9.73 2.86-12.71 4.05-1.92.77-6.11 1.53-8.79 1.26-3.19-.33-6.61-1.07-13.33-.42-6.67.65-11.56 2.74-12.51 3.07-.94.33-3.53.87-4.41 1.17-.88.31.72 3.65 1.37 3.79.66.14 2.41.18 2.84 1.06.43.88 2.71 7.82 4.12 9.02 1.42 1.2 6.28 1.7 11.02 1.32 3.89-.31 9.09-2.19 10.07-3.5.84-1.13 1.63-3.01 2.35-6 .74-3.08.69-5.09 1.3-5.56.61-.47 3.83-.83 4.32-.63.72.28 1.22 2.24 2.77 4.99 1.51 2.69 2.78 4.28 3.89 5.14 1.3 1 6.81 1.39 10.64.62 4.67-.94 9.21-2.75 10.25-4.29 1.04-1.54 1.33-8.84 1.51-9.81.18-.97 2.14-1.13 3.1-1.68s1.36-4.46.34-4.46Zm-40.58 14.51c-.33 2.39-1.22 4.19-1.96 5.49-.74 1.3-5.51 2.82-8.83 2.99-3.66.18-7.42-.5-8.58-1.24-1.16-.75-2.07-3.59-2.48-6.22-.41-2.63-.38-4.47.14-5.33.61-1.01 5.53-1.69 10.39-2.06 4.51-.34 9.69-.1 10.9.59 1.2.69.75 3.38.42 5.77Zm33.36.08c-.91 1.03-4.14 2.5-7.71 3.32-3.24.75-8.25.59-9.31-.46-1.06-1.05-2.42-2.54-3.38-4.75-.97-2.21-2.13-4.67-1.17-5.67.97-1 5.89-2.65 10.32-3.55 4.77-.97 9.5-1.44 10.36-.63.73.68 1.26 2.44 1.58 5.08.32 2.64.22 5.62-.69 6.66Z"
        style={{
          fill: '#e95d0f',
        }}
      />
    </svg>
  )
}
export default AdoptiveDadEnd
